import { render, staticRenderFns } from "./BusinessSkills.vue?vue&type=template&id=67557d7b&scoped=true&"
import script from "./BusinessSkills.vue?vue&type=script&lang=js&"
export * from "./BusinessSkills.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSkills.vue?vue&type=style&index=0&id=67557d7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67557d7b",
  null
  
)

export default component.exports